// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    crmCardButtonText: "Get Started",
    crmCardImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/hp-jan-26/ai-products/products-crm.avif",
        alt: ""
    },
    crmCardParagraph: "Automate full customer journeys with the most intuitive CRM, powered by AI insights.",
    crmCardTitle: "AI-first CRM that delivers revenue",
    devCardButtonText: "Get Started",
    devCardImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/hp-jan-26/ai-products/products-dev.avif",
        alt: ""
    },
    devCardParagraph: "Plan roadmaps, manage sprints, and release products without scaling complexity.",
    devCardTitle: "Ship products faster, from idea to release",
    headingBlack: "Solve every work challenge with ",
    headingGradient: "AI-powered products",
    hideComponent: true,
    sectionSmallTagline: "AI-powered product suite",
    sectionSubtitle: "Each product solves departmental needs, and together, they power seamless operations across your organization.",
    serviceCardButtonText: "Get Started",
    serviceCardImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/hp-jan-26/ai-products/products-svc.avif",
        alt: ""
    },
    serviceCardParagraph: "Empower every team to deliver efficient service at scale with built-in intelligence.",
    serviceCardTitle: "AI service that drives resolutions at scale",
    wmCardButtonText: "Get Started",
    wmCardImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/hp-jan-26/ai-products/products-wm.avif",
        alt: ""
    },
    wmCardParagraph: "Drive projects and processes forward at scale, with AI that executes, builds, and automates for you",
    wmCardTitle: "AI-driven planning, execution & delivery"
};
